// Tipo Venta
export const TIPO_VENTA_CONTADO = "P";
export const TIPO_VENTA_CREDITO = "C";
export const TIPO_VENTA_TODOS = "T";
export const TIPO_VENTA_CONTADO_LABEL = "Contado";
export const TIPO_VENTA_CREDITO_LABEL = "Crédito";
export const TIPO_VENTA_TODOS_LABEL = "Todos";

export const TIPO_FACTURACION_RETAIL = "R";
export const TIPO_FACTURACION_GASOLINERA = "G";
export const TIPO_FACTURACION_RETAIL_LABEL = "Retail";
export const TIPO_FACTURACION_GASOLINERA_LABEL = "Gasolinera";

export class TerminalPOS {
  // Estatus
  static ESTATUS_ACTIVO = "A";
  static ESTATUS_ACTIVO_LABEL = "Activo";
  static ESTATUS_INACTIVO = "I";
  static ESTATUS_INACTIVO_LABEL = "Inactivo";
  static ESTATUS_EN_ESPERA_ACEPTACION = "E";
  static ESTATUS_EN_ESPERA_ACEPTACION_LABEL = "En Espera de Aceptación";

  // Configuración

  static get ESTATUS_LIST() {
    return [
      { value: TerminalPOS.ESTATUS_ACTIVO, label: TerminalPOS.ESTATUS_ACTIVO_LABEL },
      { value: TerminalPOS.ESTATUS_INACTIVO, label: TerminalPOS.ESTATUS_INACTIVO_LABEL },
      { value: TerminalPOS.ESTATUS_EN_ESPERA_ACEPTACION, label: TerminalPOS.ESTATUS_EN_ESPERA_ACEPTACION_LABEL },
    ];
  }

  static get TIPO_VENTA_LIST() {
    return [
      { value: TIPO_VENTA_CONTADO, label: TIPO_VENTA_CONTADO_LABEL },
      { value: TIPO_VENTA_CREDITO, label: TIPO_VENTA_CREDITO_LABEL },
      { value: TIPO_VENTA_TODOS, label: TIPO_VENTA_TODOS_LABEL }
    ];
  }

  static get TIPO_FACTURACION_LIST() {
    return [
      { value: TIPO_FACTURACION_RETAIL, label: TIPO_FACTURACION_RETAIL_LABEL },
      { value: TIPO_FACTURACION_GASOLINERA, label: TIPO_FACTURACION_GASOLINERA_LABEL }
    ];
  }

  static get DEFAULT_ESTATUS_VALUE() {
    return TerminalPOS.ESTATUS_ACTIVO;
  }

  static get PROPIEDADES_EXPORTAR() {
    return [
      { value: "IdSec", label: "Id" },
      { value: "NombreDispositivo", label: "Nombre" },
      { value: "ModeloDispositivo", label: "Modelo" },
      { value: "VersionFirmware", label: "Versión de Android" },
      { value: "IMEI", label: "IMEI" },
      { value: "TipoFacturacionDesc", label: "Configuración" },
      { value: "EstatusDesc", label: "Estatus" },
      { value: "CrearUsuario", label: "Usuario Creación" },
      { value: "FechaCreacion", label: "Fecha Creación" },
      { value: "ActualizarUsuario", label: "Usuario Actualización" },
      { value: "FechaActualizacion", label: "Fecha Actualización" },
    ];
  }
}
